module.exports = __webpack_public_path__ + "img/jjooJuventud6.fe136d3c.jpg";